import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const FLUID_PARAMS = [
  {
    kind: 'int',
    key: 'resolution',
    label: 'Gitterauflösung',
    min: 48,
    max: 400,
    step: 8,
    default: 168,
    unit: 'Zellen',
    neverRandomise: true,
    group: 'Simulation',
    tooltip: 'Breite des Simulationsgitters. Der Löser ist O(n²) pro Iteration.',
  },
  {
    kind: 'float',
    key: 'viscosity',
    label: 'Viskosität',
    min: 0,
    max: 0.0008,
    step: 0.000005,
    default: 0.00008,
    precision: 6,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'diffusion',
    label: 'Diffusion',
    min: 0,
    max: 0.0006,
    step: 0.000005,
    default: 0.00002,
    precision: 6,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'decay',
    label: 'Zerfallsrate',
    min: 0,
    max: 0.06,
    step: 0.001,
    default: 0.006,
    precision: 3,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'vorticity',
    label: 'Wirbelstärke',
    min: 0,
    max: 40,
    step: 0.5,
    default: 12,
    group: 'Simulation',
    tooltip: 'Vorticity confinement — gibt dem numerisch geglätteten Feld seine Wirbel zurück.',
  },
  {
    kind: 'int',
    key: 'steps',
    label: 'Gesamtschritte',
    min: 10,
    max: 1500,
    step: 5,
    default: 220,
    bulkRange: [60, 500],
    group: 'Simulation',
  },

  {
    kind: 'enum',
    key: 'source',
    label: 'Injektionsquelle',
    default: 'outline',
    group: 'Injektion',
    options: [
      { value: 'outline', label: 'Textkontur' },
      { value: 'bottom', label: 'Unterer Rand' },
      { value: 'sides', label: 'Seiten' },
      { value: 'points', label: 'Zufallspunkte' },
    ],
  },
  {
    kind: 'float',
    key: 'injection',
    label: 'Injektionsrate',
    min: 0.05,
    max: 6,
    step: 0.05,
    default: 1.5,
    group: 'Injektion',
  },
  {
    kind: 'float',
    key: 'force',
    label: 'Anfangskraft',
    min: 0,
    max: 60,
    step: 0.5,
    default: 16,
    group: 'Injektion',
  },
  {
    kind: 'int',
    key: 'injectUntil',
    label: 'Injektion bis Schritt',
    min: 1,
    max: 800,
    step: 1,
    default: 90,
    group: 'Injektion',
  },
  {
    kind: 'bool',
    key: 'obstacle',
    label: 'Text als Hindernis',
    default: true,
    group: 'Injektion',
  },

  {
    kind: 'bool',
    key: 'showVelocity',
    label: 'Geschwindigkeitsfeld zeigen',
    default: false,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'contrast',
    label: 'Kontrast',
    min: 0.2,
    max: 6,
    step: 0.05,
    default: 1.3,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Darstellung',
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Farbrampe',
    default: { ...DEFAULT_PALETTE, paletteId: 'cyberpunk' },
    group: 'Darstellung',
  },
] as const satisfies ParamSchema;

export type FluidValues = SchemaValues<typeof FLUID_PARAMS>;
